export default __webpack_public_path__ + "static/media/yurinya_icon.4dc58310.png";